import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../services/app.service';

@Pipe({
  name: 'elsoGridFilter',
  pure: false
})
export class ELSOFilterPipe implements PipeTransform {
  constructor(public appService: AppService) { }

  transform(items: any[], filter: string, sortByProperty?: string, sortByOrder?: string, filterByChildProperty?: string): any {
    //console.log(sortByProperty);
    if (!items) {
      return items;
    }
    var sortedFilteredArray = items;
    var sortByOrderDefault = 'asc';
    if (sortByOrder) {
      sortByOrderDefault = sortByOrder
    }

    if (sortByProperty) {
      sortedFilteredArray = this.appService.lodashOrderBy(sortedFilteredArray, [sortByProperty], [sortByOrderDefault]);
    }

    //if (filterByChildProperty) {
    //  sortedFilteredArray = this.filterByChildProperty(sortedFilteredArray, sortByProperty, filterByChildProperty);
    //}

    if (filter) {
      if (filter.trim() != "") {
        sortedFilteredArray = this.filterByValue(sortedFilteredArray, filter);
      }
    }
    return sortedFilteredArray;
  }

  filterByValue(array, string) {
    return array.filter(o => {
      return Object.keys(o).some(k => {
        if (o[k] != null)
          return o[k].toString().toLowerCase().includes(string.toLowerCase())
      })
    });
  }


  filterByChildProperty(array, property, filterByChildProperty) {
    const sortedByNewestChild = array.sort((a, b) => {
      // 1. Extract timestamps of all children for parent A and parent B
      const datesA = a[filterByChildProperty].map(child => new Date(child[property]).getTime());
      const datesB = b[filterByChildProperty].map(child => new Date(child[property]).getTime());

      // 2. Find the maximum (newest) timestamp for each parent
      const maxA = Math.max(...datesA);
      const maxB = Math.max(...datesB);

      // 3. Compare them (use "maxB - maxA" for Descending, "maxA - maxB" for Ascending)
      return maxB - maxA;
    });

    return sortedByNewestChild;
  }


 

}
